import { useMemo } from "react";
import { BaseODataV4AdaptorOptions } from "./BaseODataV4Adaptor";
import { ODataProps, useOData } from "./useOData";
import { utils } from "../..";

export interface UseBaseODataManagerHookProps<TData = any>
  extends ODataProps,
    BaseODataV4AdaptorOptions<TData> {
  apiBaseUrl: string;
  odataPath?: string;
}

export const useBaseODataManager = <TData = any>(
  props: UseBaseODataManagerHookProps<TData>
) => {
  const odataUrl = useMemo(() => {
    return `${utils.strings.trimEndForwardSlashForURL(props.apiBaseUrl)}/${
      props.odataPath || ""
    }`;
  }, [props.apiBaseUrl, props.odataPath]);

  const { setupBaseODataManager, odataReady } = useOData(props);

  const dataManager = useMemo(() => {
    if (!odataReady) return null;

    return setupBaseODataManager<TData>(odataUrl, {
      transformData: props.transformData,
      beforeSendFn: props.beforeSendFn,
      removeLeadingQuestionMark: props.removeLeadingQuestionMark,
      removeUnsupportedParameters: props.removeUnsupportedParameters,
      replaceUndefinedInQueryStringWithNulls:
        props.replaceUndefinedInQueryStringWithNulls,
    });
  }, [
    odataReady,
    odataUrl,
    props.transformData,
    props.beforeSendFn,
    props.removeLeadingQuestionMark,
    props.removeUnsupportedParameters,
    props.replaceUndefinedInQueryStringWithNulls,
  ]);

  return { dataManager };
};
